/**
 * Lazy `toast` — same call shape as `import { toast } from "sonner"` but the
 * sonner runtime (~10 KB gzipped) is only downloaded the first time a toast
 * is actually shown. Used by the components that live in the main bundle;
 * lazy-loaded pages import sonner directly.
 */
const load = () => import("sonner");

const proxy = (method) => (...args) => {
  load().then((m) => m.toast[method](...args)).catch(() => {});
};

export const toast = Object.assign(
  (...args) => {
    load().then((m) => m.toast(...args)).catch(() => {});
  },
  {
    error: proxy("error"),
    success: proxy("success"),
    info: proxy("info"),
    warning: proxy("warning"),
    message: proxy("message"),
    dismiss: proxy("dismiss"),
  }
);
